import { Button, Row, Col } from "react-bootstrap"
import ProfileImage from "./ProfileImage"
import { SessionDetails } from "../api/auth/actions"
import Label from "./Label"
import { ADMIN_ROLE, OWNER_ROLE } from "../constants"
import Loading from "./Loading"

type UserItemProps = {
    user: SessionDetails
    onClick: () => void
}

const ProfileCardPreview: React.FC<UserItemProps> = ({ onClick, user }) => {
    if (user === null) return <Loading />

    let role = ""
    if (user.roles.length > 0) {
        switch (user.roles[0]) {
            case ADMIN_ROLE:
                role = "Admin"
                break
            case OWNER_ROLE:
                role = "Owner"
                break
        }
    }
    return <Button
        className="profile-preview"
        variant="outline-primary"
        onClick={(e) => onClick()}>
        <Row>
            <Col sm="auto">
                <ProfileImage name={user.dis} src={user.avatar} size={45} bgcolor="#D9D9D9" />
            </Col>
            <Col>
                <Label padding="0" size="medium">{"Hello " + user.dis}</Label>
                <Label padding="0" size="medium" color="gray" fontWeight="400">
                    {role}
                </Label>
            </Col>
        </Row>
    </Button>
}

export default ProfileCardPreview